export default "__VITE_ASSET__DxDnEQJp__"